import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EntityManager } from '@dch/entity-manager';
import { of } from 'rxjs';
import {
  map,
  mergeMap,
  catchError,
  distinctUntilKeyChanged,
} from 'rxjs/operators';
import {
  getExtraCostConfigFileFailure,
  getExtraCostConfigFileRequest,
  getExtraCostConfigFileSuccess,
} from '../actions';
import { EXTRA_COST_ENTITY } from 'src/app/my-bill/config/my-bill-entity.config';

@Injectable()
export class ExtraCostEffects {
  getConfigFile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getExtraCostConfigFileRequest),
      mergeMap(() =>
        EntityManager.getEntity<string>(EXTRA_COST_ENTITY).pipe(
          distinctUntilKeyChanged('value'),
          map((entity) =>
            entity.value
              ? getExtraCostConfigFileSuccess({ csvResponse: entity.value })
              : getExtraCostConfigFileFailure()
          ),
          catchError((error) => of(getExtraCostConfigFileFailure()))
        )
      )
    )
  );

  constructor(private actions$: Actions) {}
}
